import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getList, getDetail, add, update, remove, enable } from "@/api/resource/oss";
import { mapGetters } from "vuex";
import func from "@/util/func";
import { queryTenantList } from "@/api/system/dictbiz";
export default {
  data: function data() {
    return {
      form: {},
      query: {},
      loading: true,
      box: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      tenantList: [],
      tenantVal: '',
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        menuWidth: 300,
        labelWidth: 100,
        dialogWidth: 880,
        dialogClickModal: false,
        column: [{
          label: "分类",
          type: "radio",
          value: 1,
          span: 24,
          width: 100,
          searchLabelWidth: 50,
          row: true,
          dicUrl: "/api/blade-system/dict/dictionary?code=oss",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          dataType: "number",
          slot: true,
          prop: "category",
          search: true,
          rules: [{
            required: true,
            message: "请选择分类",
            trigger: "blur"
          }]
        }, {
          label: "资源编号",
          prop: "ossCode",
          span: 24,
          width: 120,
          search: true,
          rules: [{
            required: true,
            message: "请输入资源编号",
            trigger: "blur"
          }]
        }, {
          label: "资源地址",
          prop: "endpoint",
          span: 24,
          rules: [{
            required: true,
            message: "请输入资源地址",
            trigger: "blur"
          }]
        }, {
          label: "空间名",
          prop: "bucketName",
          span: 24,
          width: 120,
          rules: [{
            required: true,
            message: "请输入空间名",
            trigger: "blur"
          }]
        }, {
          label: "accessKey",
          prop: "accessKey",
          span: 24,
          search: true,
          width: 200,
          overHidden: true,
          rules: [{
            required: true,
            message: "请输入accessKey",
            trigger: "blur"
          }]
        }, {
          label: "secretKey",
          prop: "secretKey",
          span: 24,
          width: 200,
          overHidden: true,
          rules: [{
            required: true,
            message: "请输入secretKey",
            trigger: "blur"
          }]
        }, {
          label: "appId",
          prop: "appId",
          span: 24,
          hide: true,
          display: false
        }, {
          label: "region",
          prop: "region",
          span: 24,
          hide: true,
          display: false
        }, {
          label: "是否启用",
          prop: "status",
          span: 24,
          width: 80,
          align: "center",
          slot: true,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false
        }, {
          label: "备注",
          prop: "remark",
          span: 24,
          hide: true
        }]
      },
      data: [],
      debugForm: {
        code: ''
      },
      debugOption: {
        submitText: "提交",
        column: [{
          label: "资源编号",
          prop: "code",
          disabled: true,
          span: 24
        }, {
          label: "上传背景",
          prop: "backgroundUrl",
          type: 'upload',
          listType: 'picture-img',
          action: '/api/blade-resource/oss/endpoint/put-file',
          propsHttp: {
            res: 'data',
            url: 'link'
          },
          span: 24
        }]
      }
    };
  },
  watch: {
    'form.category': function formCategory() {
      var category = func.toInt(this.form.category);
      this.$refs.crud.option.column.filter(function (item) {
        if (item.prop === "appId") {
          item.display = category === 4;
        }

        if (item.prop === "region") {
          item.display = category === 4;
        }
      });
    },
    'debugForm.code': function debugFormCode() {
      var column = this.findObject(this.debugOption.column, "backgroundUrl");
      column.action = "/api/blade-resource/oss/endpoint/put-file?code=".concat(this.debugForm.code);
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["userInfo", "permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.oss_add),
        viewBtn: this.vaildData(this.permission.oss_view),
        delBtn: this.vaildData(this.permission.oss_delete),
        editBtn: this.vaildData(this.permission.oss_edit)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  methods: {
    getTenantList: function getTenantList() {
      var _this = this;

      if (!this.tenantVal) {
        queryTenantList().then(function (res) {
          console.log(res, '--res');
          _this.tenantList = res.data.data;
          _this.tenantVal = _this.tenantList[0].tenantId;
        });
      }
    },
    rowSave: function rowSave(row, done, loading) {
      var _this2 = this;

      var data = Object.assign({}, row, {
        tenantId: this.tenantVal
      });
      add(data).then(function () {
        _this2.onLoad(_this2.page);

        _this2.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this3 = this;

      var data = Object.assign({}, row, {
        tenantId: this.tenantVal
      });
      update(data).then(function () {
        _this3.onLoad(_this3.page);

        _this3.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row) {
      var _this4 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id, _this4.tenantVal);
      }).then(function () {
        _this4.onLoad(_this4.page);

        _this4.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleEnable: function handleEnable(row) {
      var _this5 = this;

      this.$confirm("是否确定启用这条配置?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return enable(row.id, _this5.tenantVal);
      }).then(function () {
        _this5.onLoad(_this5.page);

        _this5.$message({
          type: "success",
          message: "操作成功!"
        });

        _this5.$refs.crud.toggleSelection();
      });
    },
    handleDebug: function handleDebug(row) {
      this.box = true;
      this.debugForm.code = row.ossCode;
      this.debugForm.backgroundUrl = '';
    },
    handleSubmit: function handleSubmit(form, done) {
      this.$message({
        type: "success",
        message: "\u83B7\u53D6\u5230\u56FE\u7247\u5730\u5740:[".concat(form.backgroundUrl, "]")
      });
      done();
    },
    handleDelete: function handleDelete() {
      var _this6 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this6.ids, _this6.tenantVal);
      }).then(function () {
        _this6.onLoad(_this6.page);

        _this6.$message({
          type: "success",
          message: "操作成功!"
        });

        _this6.$refs.crud.toggleSelection();
      });
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this7 = this;

      if (["edit", "view"].includes(type)) {
        getDetail(this.form.id, this.tenantVal).then(function (res) {
          _this7.form = res.data.data;
        });
      }

      done();
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this8 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      this.getTenantList();
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query, {
        tenantId: this.tenantVal
      })).then(function (res) {
        var data = res.data.data;
        _this8.page.total = data.total;
        _this8.data = data.records;
        _this8.loading = false;

        _this8.selectionClear();
      });
    }
  }
};